import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
    routes: [
        {
            path: '/',
            component: () => import('../views/Home.vue')
        },
        {
            path: '/news',
            name: 'News',
            component: () => import('../views/News.vue')
        },
        {
            path: '/r/:id',
            component: () => import('../views/Recipe.vue')
        },
        {
            path: '/n/:source/:title',
            component: () => import('../views/Article.vue')
        },
        {
            path: '/search',
            component: () => import('../views/Search.vue')
        },
        {
            path: '*'
        }
    ]
})

router.afterEach((to, from) => {
    if (!Vue.$install.CheckInstall()) return false;

    Vue.prototype.$fromRoute = from;
    Vue.$impressions.sendEvent('app_navigation', to.path);

    if (to.path === '/') document.title = 'My Recipe Finder';
    else document.title = (to.name || 'Loading...') + ' - My Recipe Finder';

    if (to.path === '*')
        this.router.push('/')
});

export default router;